import { put, call, takeLatest } from 'redux-saga/effects'
import { errorHandler } from '../../../core/helpers/errorHelpers'
import { fetchTalentAdvisorEntitySaga } from '../../../core/sagas/talentAdvisors'
import { fetchCandidateProfileEntitySaga } from '../../../core/sagas/candidateProfiles'

import * as interviewRequestDetailsView from '../modules/interviewRequestDetails'

export function* fetchCandidateProfileSaga({ meta }) {
  try {
    const response = yield call(fetchCandidateProfileEntitySaga, meta.id)
    yield put(interviewRequestDetailsView.fetchCandidateProfileSuccess(response.result))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(interviewRequestDetailsView.fetchCandidateProfileError(error))
  }
}

export function* fetchTalentAdvisorSaga({ meta }) {
  try {
    const response = yield call(fetchTalentAdvisorEntitySaga, meta.id)
    yield put(interviewRequestDetailsView.fetchTalentAdvisorSuccess(response.result))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(interviewRequestDetailsView.fetchTalentAdvisorError(error))
  }
}

export default function* watchTalentAdvisorSaga() {
  yield takeLatest(interviewRequestDetailsView.FETCH_CANDIDATE_PROFILE, fetchCandidateProfileSaga)
  yield takeLatest(interviewRequestDetailsView.FETCH_TALENT_ADVISOR, fetchTalentAdvisorSaga)
}
